<template>
  <b-layout :colors="$site.colors" :header-title="title" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <gift
          :title="$t('general.giftcard')"
          :img="giftCardImage"
          :info="$site.location.title"
          :price="$t('pages.gift.index.currencyVaries', {currency: $site.location.currencySymbol})"
          :to="{ path: '/gift/card' }"
        />

        <template v-if="passes && passes.length">
          <gift
            v-for="pass in passes" 
            :key="pass.id"
            :title="pass.name"
            :img="passImage(pass)"
            :info="pass.information ? formatHtml(pass.information) : $t('general.pass')"
            :price="pass.priceLabel"
            :to="{ path: '/gift/pass', query: { id: pass.id } }"
          />
        </template>
      </div>
    </b-container>
  </b-layout>
</template>

<script>
import Utils from '@/utils'

import Gift from '@/components/gift/elements/Gift'

definePageMeta({
  tabs: ['giftCard']
});

export default defineNuxtComponent({
  components: {
    Gift
  },
  computed: {
    title() {
      return this.$site.tabs.giftCard?.name || ''
    },
    homeRoute() {
      return this.$store.getters.homeRoute || { path: '/' }
    },
    giftCardImage() {
      if (this.$site.images.giftCard) {
        return this.$site.images.giftCard.large
      }
      return null
    }
  },
  async asyncData () {
    const route = useRoute()
    const { $api } = useNuxtApp()
    const query = route.query

    try {
      const response = await $api.pass.giftable()

      if (!response.passes.length) {
        navigateTo({ path: '/gift/card', query })
      }

      return {
        passes: response.passes,
        error: false
      }
    } catch (error) {
      return {
        passes: null,
        error: true
      }
    }
  },
  methods: {
    formatHtml(text) {
      return Utils.text.formatHtml(text)
    },
    selectPass(pass) {
      this.$router.push({ path: '/gift/pass', query: { id: pass.id } })
    },
    selectGiftCard() {
      this.$router.push({ path: '/gift/card' })
    },
    passImage(pass) {
      if (pass.images) {
        return pass.images.large
      } else if (this.$site.images.pass) {
        return this.$site.images.pass.large
      }
      return null
    }
  }
})
</script>
